import React, { useEffect, useState } from "react";
import "./LoginAuth.css";
import { useOktaAuth } from "@okta/okta-react";
import { toast } from "react-toastify";
import { authClient } from "../../Utils/Common";
import { Checkbox } from "@mui/material";
import JobsLogo from "../../Assets/jobslogo.svg";
import { clearAllChatSelections } from "../Chat/utils/chatSelectionsStorage";
const LoginAuth = () => {
  const auth = useOktaAuth();
  // const loggingIn = (e) => {
  //   authClient?.token
  //     .getWithRedirect({
  //       responseType: ["token", "id_token"],
  //       state: "defaultrandomstring",
  //     })
  //     .catch(function (err) {
  //       console.error("Error OKTA login redirect", err);
  //     });
  // };
  const loggingIn = (e: React.SyntheticEvent) => {
  authClient
    .signInWithRedirect()
    .catch(function (err) {
      console.error("Error OKTA login redirect", err);
    });
};
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [showMore, setShowMore] = useState(false);
  const [CheckboxSelected, setCheckboxSelected] = useState(false);

  const loggingOut = async () => auth.oktaAuth.signOut();
  const handleReadMore = () => {
    setShowMore(!showMore);
  };
  const DisableLogin = () => {
    if (CheckboxSelected === false) {
      toast.error("Please tick the checkbox to Login");
      return false;
    }
    return true;
  };
  // useEffect(() => {
  //   window.localStorage.clear();
  //   window.sessionStorage.clear();
  // }, []);

  // This screen only shows when signed out (PublicRoute), so reaching it
  // means a fresh login is coming — whether the user logged out or their
  // Okta session simply expired. Each chat's saved picks only last until
  // then (see chatSelectionsStorage).
  useEffect(() => {
    clearAllChatSelections();
  }, []);
  return (
    <>
      <section className="login-section-main">
        <div className="section-login-after-main">
          <div>
            <img src={JobsLogo} alt="logo" className="logo-login" />
          </div>
          <div className="login-card-main">
            <div className="login-card-content-section">
              <div className="heading-content-section">
                <h2>Login with Okta</h2>

                <div className="Useragreement">
                  <p className="Login-screen-agree-heading">
                    JO Enterprise Chat User Agreement: For Authorized Use Only
                  </p>
                </div>

                <div className="login-screen-hide-data">
                  <p>
                    The data and information contained in the JO Enterprise Chat are CONFIDENTIAL and strictly intended 
                    for official JobsOhio INTERNAL USE only. It is not a substitute for professional judgment, decision-making, 
                    and understanding JobsOhio’s policies and processes.{" "}
                    <span
                      className="login-page-reacd-more"
                      onClick={handleReadMore}
                    >
                    </span>
                  </p>
                  <div className="login-screen-hide-data">
                    <p>
                      The information contained in the JO Enterprise Chat is not for external distribution or data monetization for profit. 
                      Users will only see information based on their permission level in the Box platform. The data, information and chatbot 
                      responses shall not be used, reproduced, distributed, or communicated to any unauthorized persons, external stakeholders, 
                      or other third parties.{" "}
                    </p>
                    <p>
                      All use of the JO Enterprise Chat is monitored and subject to periodic audit for security and administrative purposes. 
                      When you access the JO Enterprise Chat, you are consenting to such monitoring. Use of the JO Enterprise Chat in violation of 
                      these terms is strictly prohibited and constitutes a violation of the JobsOhio Standards of Conduct and the JobsOhio Employee 
                      Handbook.{" "}
                    </p>
                    <p>
                      For questions or
                      support, please email{" "}
                      <a href="mailto:enterprisedata@jobsohio.com">
                        enterprisedata@jobsohio.com
                      </a>
                    </p>
                    <p>
                      By checking this box and/or clicking “login” below, you are agreeing to the terms and conditions set forth above.{" "}
                      <span
                        className="login-page-reacd-more"
                        onClick={handleReadMore}
                      ></span>
                    </p>
                  </div>
                  {/* )} */}
                </div>
                <div className="Login-screencheckbox">
                  <Checkbox
                    {...label}
                    checked={CheckboxSelected}
                    onChange={(e) => setCheckboxSelected(e.target.checked)}
                    size="small"
                  />
                  <p>I agree to the above and wish to continue</p>
                </div>

                <form onSubmit={loggingIn}>
                  <div className="login-button-section">
                    {!CheckboxSelected ? (
                      <button
                        type="button"
                        onClick={DisableLogin}
                        className="disablebutton"
                      >
                        Login
                      </button>
                    ) : (
                      <button type="button" onClick={loggingIn}>
                        Login
                      </button>
                    )}
                  </div>

                  <div className="login-button-section-okta">
                    {auth.authState?.isAuthenticated ? (
                      <button type="submit" onClick={loggingOut}>
                        Logout
                      </button>
                    ) : null}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LoginAuth;
